module.exports = __webpack_public_path__ + "static/img/yinqing.931cc36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/yinqing.png
// module id = OVm+
// module chunks = 0